import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './contexts/AuthContext';
import { useAuth } from './contexts/AuthContext';
import SignInPopUp from './components/SignInPopUp';
import SignUpPopUp from './components/SignUpPopUp';
import Contact from './components/Contact';
import HomePage from './components/HomePage';
import Horoscope from './components/Horoscope';
import Consultation from './components/Consultation';
import Astrology from './components/Astrology';
import Zodiac from './components/Zodiac';
import UserProfile from './components/UserProfile';
import MyBookings from './components/MyBookings';
import Demo from './components/demo';
import About from './components/About';
import SpecialOffer from './components/SpecialOffer';
import AdminPage from './components/AdminPage';
import ScrollToTop from './components/ScrollToTop';

function ProtectedRoute({ children, requiredRole }) {
  const { user, isAuthenticated, loading } = useAuth();
  if (loading) return null;
  if (!isAuthenticated || !user) return <Navigate to="/" replace />;
  if (requiredRole && !user.roles?.includes(requiredRole)) return <Navigate to="/" replace />;
  return children;
}

function App() {
  const [showSignIn, setShowSignIn] = useState(false);
  const [showSignUp, setShowSignUp] = useState(false);

  const openSignIn = () => {
    setShowSignIn(true);
    setShowSignUp(false);
    document.body.style.overflow = 'hidden';
  };

  const openSignUp = () => {
    setShowSignUp(true);
    setShowSignIn(false);
    document.body.style.overflow = 'hidden';
  };

  const closePopups = () => {
    setShowSignIn(false);
    setShowSignUp(false);
    document.body.style.overflow = 'unset';
  };

  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage onNavigateToSignIn={openSignIn} />} />
          <Route path="/contact" element={<Contact onNavigateToSignIn={openSignIn} />} />
          <Route path="/horoscope" element={<Horoscope />} />
          <Route path="/consultation" element={<Consultation onNavigateToSignIn={openSignIn} />} />
          <Route path="/astrology" element={<Astrology onNavigateToSignIn={openSignIn} />} />
          <Route path="/zodiac/:zodiacSign" element={<Zodiac onNavigateToSignIn={openSignIn} />} />
          <Route path="/profile" element={<UserProfile />} />
          <Route path="/my-bookings" element={<MyBookings onNavigateToSignIn={openSignIn} />} />
          <Route path="/about" element={<About onNavigateToSignIn={openSignIn} />} />
          <Route path="/special-offer" element={<SpecialOffer onNavigateToSignIn={openSignIn} />} />

          <Route path="/admin" element={
            <ProtectedRoute requiredRole="ADMIN"><AdminPage /></ProtectedRoute>
          } />
          <Route path="/demo" element={<Demo />} />
        </Routes>

        {showSignIn && (
          <SignInPopUp
            onNavigateToSignUp={openSignUp}
            onClose={closePopups}
          />
        )}

        {showSignUp && (
          <SignUpPopUp
            onNavigateToSignIn={openSignIn}
            onClose={closePopups}
          />
        )}
      </Router>
    </AuthProvider>
  );
}

export default App;


